export const defaultValues = {
    nip: '',
};

export interface NipVerificationProperties {
    nip: string;
}